import React, { useMemo, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import {
  ClientSideRowModelModule,
  ModuleRegistry,
  NumberEditorModule,
  NumberFilterModule,
  PaginationModule,
  RowSelectionModule,
  TextEditorModule,
  TextFilterModule,
  ValidationModule,
} from "ag-grid-community";
import { useDispatch, useSelector } from "react-redux";
import { GamehistorySlice } from "../../redux/slices/gamehistory";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import { useNavigate } from "react-router";
import moment from "moment";
// Register AG Grid modules
ModuleRegistry.registerModules([
  NumberEditorModule,
  TextEditorModule,
  TextFilterModule,
  NumberFilterModule,
  RowSelectionModule,
  PaginationModule,
  ClientSideRowModelModule,
  ValidationModule,
]);

const ResponsiveTransactionTable = ({ user }) => {
  const GameHistory = useSelector((state) => state?.gh?.data);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(GamehistorySlice());
  }, [user]);

  const handleStatusClick = (params) => {
    console.log("handleStatusClick");
  };
  const columnDefs = useMemo(
    () => [
      {
        headerName: "SR#",
        colId: "rowNum",
        valueGetter: (params) => parseInt(params.node.id) + 1,
        width: 20,
        minWidth: 50,
        maxWidth: 50,
      },
      { field: "game", minWidth: 150, headerName: "Name" },
      {
        field: "balance",
        minWidth: 150,
        maxWidth: 150,
        headerName: "Before Balance",

        cellRenderer: (params) => {
          return `$${params.value}`;
          // const FilterVBal = (count) =>
          //   params?.data?.bl?.filter((v, i, m) =>
          //     m.includes(count) ? true : false
          //   );

          // if (FilterVBal(10).length > 0) {
          //   return params.value;
          // } else if (FilterVBal(2).length > 0) {
          //   const res = params.value + params?.data?.deposit;
          //   return res - params?.data?.deposit;
          // } else if (FilterVBal(4).length > 0) {
          //   return params.value;
          // }
          // if (FilterVBal?.length > 0) {
          //   return params.value - params?.data?.deposit;
          // }
        },
      },
      {
        field: "radeem",
        minWidth: 120,
        maxWidth: 120,
        headerName: "Redeem",
        cellRenderer: (params) => `-$${params.value}`,
      },
      {
        field: "deposit",
        minWidth: 120,
        maxWidth: 120,
        headerName: " Deposit",
        cellRenderer: (params) => `$${params.value}`,
      },
      {
        field: "balance",
        minWidth: 150,
        maxWidth: 150,
        headerName: " After Balance",
        cellRenderer: (params) => {
          const FilterVBal = (count) =>
            params?.data?.bl?.filter((v, i, m) =>
              m.includes(count) ? true : false
            );

          if (params?.data?.status === "rejected") {
            return params.value;
          }
          return `$${
            params?.data?.deposit > 0
              ? params.value - params?.data?.deposit
              : params?.data?.radeem > 0
              ? parseInt(params?.data?.radeem) + parseInt(params.value)
              : 0
          }`;
        },
      },
      {
        field: "updatedAt",
        minWidth: 150,
        headerName: "Date",
        cellRenderer: (params) =>
          moment(params.value).format("DD/MM/YY hh:mm A"),
      },
      {
        field: "status",
        minWidth: 130,
        maxWidth: 130,
        headerName: "Status",
        cellRenderer: (params) => {
          let statusValue =
            params.value === "radeem"
              ? "redeem"
              : params.value === "rejected"
              ? "rejected"
              : params.value;

          const FilterVBal = params?.data?.bl?.filter((v, i, m) =>
            m.includes(10) ? true : false
          );

          return (
            <div className="flex justify-start items-center capitalize">
              <span className="missionSpan mr-1">
                <span
                  className={`inline-flex items-center justify-center rounded-full w-4 h-4 ${
                    FilterVBal?.length
                      ? "bg-red-500"
                      : statusValue === "pending"
                      ? "bg-yellow-500"
                      : statusValue === "deposit"
                      ? "bg-green-500"
                      : "bg-green-500"
                  }`}
                >
                  {FilterVBal?.length ? (
                    <CheckOutlinedIcon
                      fontSize="small"
                      style={{ color: "white", fontSize: "16px" }}
                    />
                  ) : statusValue === "pending" ? (
                    <CheckOutlinedIcon
                      fontSize="small"
                      style={{ color: "white", fontSize: "16px" }}
                    />
                  ) : statusValue === "redeem" ? (
                    <CheckOutlinedIcon
                      fontSize="small"
                      style={{ color: "white", fontSize: "16px" }}
                    />
                  ) : statusValue === "deposit" ? (
                    <CheckOutlinedIcon
                      fontSize="small"
                      style={{ color: "white", fontSize: "16px" }}
                    />
                  ) : null}
                </span>
              </span>
              <span
                className={`cursor-pointer ${
                  params?.data?.remarks?.length > 0 &&
                  params?.data?.remarks[0] !== "" &&
                  statusValue === "rejected"
                    ? "text-sky-500 underline"
                    : ""
                }`}
                onClick={() => {
                  if (
                    params?.data?.remarks?.length > 0 &&
                    params?.data?.remarks[0] !== ""
                  ) {
                    if (statusValue === "rejected") {
                      handleStatusClick(params?.data);
                    }
                  }
                }}
              >
                {FilterVBal?.length ? "Rejected" : statusValue}
              </span>
            </div>
          );
        },
      },
    ],
    []
  );

  const defaultColDef = useMemo(
    () => ({
      editable: false,
      filter: true,
      resizable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
    }),
    []
  );

  return (
    <div className="rounded-lg shadow-lg custom-container mx-auto mt-5 pl-3 w-full sm:w-full md:w-full lg:w-[68000px] xl:w-full pb-20">
      <div className="grid-table">
        <h2 className="text-white font-bold text-[20px] sm:text-[35px] mb-4">
          Games History: Redeems & Deposits
        </h2>
        <div className="ag-theme-alpine custom-table">
          <AgGridReact
            rowData={GameHistory}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            pagination={true}
            paginationPageSize={40}
            domLayout="autoHeight"
            suppressMenuHide={true}
          />
        </div>
      </div>
    </div>
  );
};

export default ResponsiveTransactionTable;
